import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import DoubleListbox from "../../../components/UI/DoubleListbox/DoubleListbox";
import SelectAutocomplete from "../../../components/UI/SelectAutocomplete/SelectAutocomplete";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const FormRoteiroOrdenacao = ({ sequencialRoteiro: propsSequencialRoteiro, setMessageErro, setShowErro }) => {
  const [sequencialRoteiro] = useState(propsSequencialRoteiro);

  const [listaAssociados, setListaAssociados] = useState([]);
  const [listaNaoAssociados, setListaNaoAssociados] = useState([]);
  const [listaAssociadosDoubleListBox, setListaAssociadosDoubleListBox] = useState([]);
  const [listaNaoAssociadosDoubleListBox, setListaNaoAssociadosDoubleListBox] = useState([]);
  const [atividadesAssociadas, setAtivideadesAssociadas] = useState([]);
  const {
    request: requestAtividadesAssociadas,
    data: dataAtividadesAssociadas,
    errors: errorsAtividadesAssociadas,
  } = useApiClient();
  const [sequencialAtividadeSelecionada, setSequencialAtividadeSelecionada] = useState("");

  useEffect(() => {
    requestAtividadesAssociadas(apiRoutes.fiscalizacao.parametrizacao.listaAtividadesRoteiro, { sequencialRoteiro });
  }, [requestAtividadesAssociadas, sequencialRoteiro]);

  useEffect(() => {
    if (dataAtividadesAssociadas) {
      setAtivideadesAssociadas(dataAtividadesAssociadas.result);
    }
    if (errorsAtividadesAssociadas) {
      setMessageErro(errorsAtividadesAssociadas.message);
      setShowErro(true);
    }
  }, [dataAtividadesAssociadas, errorsAtividadesAssociadas, setMessageErro, setShowErro]);

  const { request: requestListaOrdenacao, data: dataListaOrdenacao, errors: errorsListaOrdenacao } = useApiClient();

  useEffect(() => {
    if (dataListaOrdenacao) {
      setListaAssociados(dataListaOrdenacao.result.associados);
      setListaNaoAssociados(dataListaOrdenacao.result.naoAssociados);
    }
    if (errorsListaOrdenacao) {
      setMessageErro(errorsListaOrdenacao.message);
      setShowErro(true);
    }
  }, [dataListaOrdenacao, errorsListaOrdenacao, setMessageErro, setShowErro]);

  const atualizarListaOrdenacao = useCallback(
    (_sequencialRoteiro, _sequencialAtividade) => {
      if (_sequencialAtividade) {
        requestListaOrdenacao(apiRoutes.fiscalizacao.parametrizacao.listaOrdenacaoAtividadeRoteiro, {
          sequencialRoteiro: _sequencialRoteiro,
          sequencialAtividade: _sequencialAtividade,
          sequencialAcaoFiscal: 0,
          sequencialAlteracaoExecutor: 0,
        });
      } else {
        setListaAssociadosDoubleListBox([]);
        setListaNaoAssociadosDoubleListBox([]);
      }
    },
    [requestListaOrdenacao],
  );

  useEffect(() => {
    let lista = [];
    listaAssociados
      .sort((a, b) => a.nomeAtividade.localeCompare(b.nomeAtividade))
      .forEach((item) => {
        lista.push({
          chave: item.sequencialAtividade,
          descricao: item.nomeAtividade,
          ordem: toString(item.nomeAtividade),
        });
      });
    setListaAssociadosDoubleListBox(lista);

    lista = [];
    listaNaoAssociados
      .sort((a, b) => a.nomeAtividade.localeCompare(b.nomeAtividade))
      .forEach((item) => {
        lista.push({
          chave: item.sequencialAtividade,
          descricao: item.nomeAtividade,
          ordem: toString(item.nomeAtividade),
        });
      });
    setListaNaoAssociadosDoubleListBox(lista);
  }, [listaAssociados, listaNaoAssociados]);

  const {
    request: incluirOrdenacaoRequest,
    data: incluirOrdenacaoData,
    errors: incluirOrdenacaoErrors,
    isLoading: isLoadingInclusao,
  } = useApiClient();

  const handleAddingOrdenacao = (item) => {
    const payload = {
      sequencialRoteiro,
      sequencialAtividade: sequencialAtividadeSelecionada,
      sequencialAtividadeOrdenacao: +item[0].chave,
    };

    incluirOrdenacaoRequest(apiRoutes.fiscalizacao.parametrizacao.incluirOrdenacaoRoteiro, payload);
  };

  useEffect(() => {
    if (!incluirOrdenacaoData && !incluirOrdenacaoErrors) return;

    if (incluirOrdenacaoData) {
      atualizarListaOrdenacao(sequencialRoteiro, sequencialAtividadeSelecionada);
      toast.success("Atividade incluída com sucesso. ");
    }

    if (incluirOrdenacaoErrors) {
      toast.error(incluirOrdenacaoErrors.message);
    }
  }, [
    sequencialRoteiro,
    sequencialAtividadeSelecionada,
    incluirOrdenacaoData,
    incluirOrdenacaoErrors,
    atualizarListaOrdenacao,
  ]);

  const {
    request: excluirOrdenacaoRequest,
    data: excluirOrdenacaoData,
    errors: excluirOrdenacaoErrors,
    isLoading: isLoadingExclusao,
  } = useApiClient();

  const handleRemovingOrdenacao = (item) => {
    const payload = {
      sequencialRoteiro,
      sequencialAtividade: sequencialAtividadeSelecionada,
      sequencialAtividadeOrdenacao: +item[0].chave,
    };

    excluirOrdenacaoRequest(apiRoutes.fiscalizacao.parametrizacao.excluirOrdenacaoRoteiro, payload);
  };

  useEffect(() => {
    if (!excluirOrdenacaoData && !excluirOrdenacaoErrors) return;

    if (excluirOrdenacaoData.value) {
      atualizarListaOrdenacao(sequencialRoteiro, sequencialAtividadeSelecionada);

      toast.success("Atividade removida com sucesso. ");
    } else {
      toast.error(excluirOrdenacaoData.message);
    }

    if (excluirOrdenacaoErrors) {
      toast.error(excluirOrdenacaoErrors.message);
    }
  }, [
    sequencialRoteiro,
    sequencialAtividadeSelecionada,
    excluirOrdenacaoData,
    excluirOrdenacaoErrors,
    atualizarListaOrdenacao,
  ]);

  return (
    <>
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <h6 className="m-0 font-weight-bold text-primary flex-grow-1">Ordenação de Atividades</h6>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>Atividade</Form.Label>
          <SelectAutocomplete
            options={atividadesAssociadas}
            optionLabel="nome"
            optionValue="sequencialAtividade"
            value={sequencialAtividadeSelecionada}
            onChange={(selectedValue) => {
              const selecionado = _.find(
                atividadesAssociadas,
                (atividade) => atividade.sequencialAtividade === selectedValue,
              );

              setSequencialAtividadeSelecionada(selecionado?.sequencialAtividade);
              atualizarListaOrdenacao(sequencialRoteiro, selecionado?.sequencialAtividade);
            }}
          />
        </Form.Group>
      </Row>
      <DoubleListbox
        tituloEsquerda="Atividades Disponíveis"
        tituloDireita="Próximas Atividades"
        textoBotaoAdicionar="Adicionar"
        textoBotaoRemover="Remover"
        disabled={isLoadingInclusao || isLoadingExclusao}
        listaEsquerda={listaNaoAssociadosDoubleListBox}
        listaDireita={listaAssociadosDoubleListBox}
        listaEsquerdaMultipla={false}
        onAdd={handleAddingOrdenacao}
        onRemove={handleRemovingOrdenacao}
        itensVisiveis={10}
      />
    </>
  );
};

export default FormRoteiroOrdenacao;
